import React from "react";

import FacilityList from "./FacilityList";
import AdminSearchWidget from "../db-list/AdminSearchWidget";
import ListWrapper from "../../../common/management/ListWrapper";
import ListContentWrapper from "../../../common/management/ListContentWrapper";

import { useGetFacilityAdmin } from "../../../utils/useFacility";
import { genDisplayCount } from "../../../utils/GeneralUtils";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

type Props = {
  handleSearch?: (search: Array<string>) => void;
  currentPage: number;
  perView: number;
  search?: Array<string>;
};

const FacilityListContainer: React.FC<Props> = ({
  handleSearch,
  currentPage,
  perView,
  search,
}) => {
  const authToken = useAppSelector(getAuthToken);

  const {
    items: { facilities, totalEntries: entries, totalPage },
    isLoading,
  } = useGetFacilityAdmin({
    authToken,
    page: currentPage,
    per: perView,
    search: search?.join(" "),
  });

  return (
    <ListWrapper
      pageTitle="施設一覧"
      btnTitle="新規作成"
      icon={["fal", "plus-circle"]}
      link="/admin/facility/create"
    >
      <ListContentWrapper
        isLoading={isLoading}
        displayCount={genDisplayCount(currentPage, totalPage, perView, entries)}
        totalEntries={entries}
        totalPage={totalPage}
        currentPage={currentPage}
        optionalComponent={
          handleSearch && search ? (
            <AdminSearchWidget handleSearch={handleSearch} search={search} />
          ) : undefined
        }
      >
        <FacilityList facilities={facilities} />
      </ListContentWrapper>
    </ListWrapper>
  );
};

export default FacilityListContainer;
